import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export default function DSAPartners() {
  const navigate = useNavigate();
  return (
    <div className="max-w-5xl mx-auto px-4 lg:px-8 py-16" data-testid="dsa-page">
      <div className="text-xs uppercase tracking-wider text-teal-700 font-semibold mb-3">For DSAs / referral partners</div>
      <h1 className="text-4xl lg:text-5xl font-semibold text-slate-900">Earn more on every used car loan you source.</h1>
      <p className="mt-5 text-slate-600 max-w-3xl leading-relaxed">Transparent commission slabs, real-time lead-to-disbursal dashboard, and a pan-India DSA support team.</p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-10">
        {[
          { t: "Lead dashboard", d: "Approval rate, login-to-approval TAT and disbursal amount visibility in one place." },
          { t: "Commission slabs", d: "Earn from 0.75% to 1.5% of disbursed amount depending on monthly volume and quality." },
          { t: "Compliance ready", d: "Account Aggregator and Bureau consent capture built in. KYC and Aadhaar consent placeholders." },
        ].map((b, i) => (
          <Card key={i} className="p-5 border-slate-200">
            <div className="font-semibold text-slate-900">{b.t}</div>
            <div className="text-sm text-slate-600 mt-2">{b.d}</div>
          </Card>
        ))}
      </div>
      <div className="mt-12 flex gap-3">
        <Button className="bg-teal-600 hover:bg-teal-700" data-testid="dsa-cta-apply" onClick={() => navigate("/contact")}>Become a DSA Partner</Button>
        <Button variant="outline" onClick={() => navigate("/login")}>DSA Sign in</Button>
      </div>
    </div>
  );
}
